'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'question';
var width = 320;
var height = 512;
var aliases = [10067,10068,61736];
var unicode = '3f';
var svgPathData = ['', 'M32 152C32 94.6 78.6 48 136 48l48 0c57.4 0 104 46.6 104 104l0 6.3c0 28.6-13.9 55.4-37.3 71.9l-95.4 67.3-3.4 2.4 0 4.1 0 64 0 8 16 0 0-8 0-59.9 92-64.9c27.6-19.5 44-51.2 44-85l0-6.3c0-66.3-53.7-120-120-120l-48 0C69.7 32 16 85.7 16 152l0 8 16 0 0-8zM176 432l-32 0 0 32 32 0 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;